/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesOrderItemAvailabilityFacets } from './SalesOrderItemAvailabilityFacets';
import {
    SalesOrderItemAvailabilityFacetsFromJSON,
    SalesOrderItemAvailabilityFacetsFromJSONTyped,
    SalesOrderItemAvailabilityFacetsToJSON,
    SalesOrderItemAvailabilityFacetsToJSONTyped,
} from './SalesOrderItemAvailabilityFacets';
import type { PagedAndSyncedResultSalesOrderItemAvailabilitySummary } from './PagedAndSyncedResultSalesOrderItemAvailabilitySummary';
import {
    PagedAndSyncedResultSalesOrderItemAvailabilitySummaryFromJSON,
    PagedAndSyncedResultSalesOrderItemAvailabilitySummaryFromJSONTyped,
    PagedAndSyncedResultSalesOrderItemAvailabilitySummaryToJSON,
    PagedAndSyncedResultSalesOrderItemAvailabilitySummaryToJSONTyped,
} from './PagedAndSyncedResultSalesOrderItemAvailabilitySummary';

/**
 * 
 * @export
 * @interface SalesOrderItemAvailabilitySummaryResponse
 */
export interface SalesOrderItemAvailabilitySummaryResponse {
    /**
     * 
     * @type {PagedAndSyncedResultSalesOrderItemAvailabilitySummary}
     * @memberof SalesOrderItemAvailabilitySummaryResponse
     */
    result: PagedAndSyncedResultSalesOrderItemAvailabilitySummary;
    /**
     * 
     * @type {SalesOrderItemAvailabilityFacets}
     * @memberof SalesOrderItemAvailabilitySummaryResponse
     */
    facets: SalesOrderItemAvailabilityFacets;
}

/**
 * Check if a given object implements the SalesOrderItemAvailabilitySummaryResponse interface.
 */
export function instanceOfSalesOrderItemAvailabilitySummaryResponse(value: object): value is SalesOrderItemAvailabilitySummaryResponse {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('facets' in value) || value['facets'] === undefined) return false;
    return true;
}

export function SalesOrderItemAvailabilitySummaryResponseFromJSON(json: any): SalesOrderItemAvailabilitySummaryResponse {
    return SalesOrderItemAvailabilitySummaryResponseFromJSONTyped(json, false);
}

export function SalesOrderItemAvailabilitySummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesOrderItemAvailabilitySummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'result': PagedAndSyncedResultSalesOrderItemAvailabilitySummaryFromJSON(json['result']),
        'facets': SalesOrderItemAvailabilityFacetsFromJSON(json['facets']),
    };
}

export function SalesOrderItemAvailabilitySummaryResponseToJSON(json: any): SalesOrderItemAvailabilitySummaryResponse {
    return SalesOrderItemAvailabilitySummaryResponseToJSONTyped(json, false);
}

export function SalesOrderItemAvailabilitySummaryResponseToJSONTyped(value?: SalesOrderItemAvailabilitySummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': PagedAndSyncedResultSalesOrderItemAvailabilitySummaryToJSON(value['result']),
        'facets': SalesOrderItemAvailabilityFacetsToJSON(value['facets']),
    };
}

